module.exports = __webpack_public_path__ + "assets/img/c465d0fe8a311dd16b9cf88d37ca1125.webp";